import React, { Children } from 'react';
import styles from './checkbox.scss';
import commonStyles from '../common.scss';
import groupStyle from '../group.scss';

import { CheckboxGroupFieldProps } from 'ui/form/fields';
import FieldLabel from 'ui/form/field-label';
import FieldNote from 'ui/form/field-note';

export default class CheckboxGroup extends React.PureComponent<CheckboxGroupFieldProps, {}> {
  renderChild = (child: React.ReactChild, index: number) => {
    if (child && child.type && child.type) {
      return <child.type key={index} {...child.props} hideNote />;
    }
    
    return child;
  };

  render() {
    const { label, children, help, error } = this.props;

    return (
      <div
        className={[styles.group, groupStyle.root, commonStyles.field].join(' ')}
        style={{ paddingBottom: help || error ? 0 : 3 }}>
        <FieldLabel label={label} error={error} />
        {Children.map(children, this.renderChild)}
        {(help || error) && <FieldNote note={help} error={error} />}
      </div>
    );
  }
}
